import { API } from 'aws-amplify';
import {
  GET_DEV_ORDERS_SUCCESS,
  GET_FLIGHT_CARDS_SUCCESS,
} from './actionTypes';
import { newNotification } from './uiActions';
import { Order } from '@m4a3/api-client';
import { FlightCard } from '../models/flight-card.interface';

export const getFlightCards = () => async dispatch => {
  return API.get('api', `/flightcard`, {})
    .then((res: FlightCard[]) => {
      dispatch({
        type: GET_FLIGHT_CARDS_SUCCESS,
        payload: res
      });
      return res;
    }
    )
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });
};

export const getAircraft = () => async dispatch => {
  return API.get('bom', `/asset?assetType=AIRCRAFT`, {})
    .then((res) => {
      return res;
    }
    )
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });
};

export const getAllRoutes = () => async dispatch => {
  return API.get('api', `/addressfind/list`, {})
    .then((res) => {
      return res;
    }
    )
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });
};

export const getDevOrders = () => async dispatch => {
  return API.get('api', `/flightcard/dev/orders`, {})
    .then((res: Order[]) => {
      const sortedIds = res
        .sort((orderA: Order, orderB: Order) => (orderA.id).localeCompare(orderB.id));
      dispatch({
        type: GET_DEV_ORDERS_SUCCESS,
        payload: sortedIds
      });
    })
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });
};

export const addFlightCard = (flightCard: FlightCard) => async dispatch => {
  return API.post('api', `/flightcard`, {
    body: flightCard
  })
    .then(res => {
      dispatch(getFlightCards())
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Added flight card'
        })
      );
    })
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });
};

export const udpateFlightCardActive = (id: string, isActive: boolean) => async dispatch => {
  return API.put('api', `/flightcard/${id}/state/${isActive}`, {
    body: {}
  })
    .then(res => {
      dispatch(getFlightCards())
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Updated flight card'
        })
      );
      return res;
    })
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });
}

export const resetFlightCard = (id: string) => async dispatch => {
  return API.put('api', `/flightcard/reset/${id}`, {
    body: {}
  })
    .then(res => {
      dispatch(getFlightCards())
      dispatch(
        newNotification({
          variant: 'success',
          message: 'Reset flight card'
        })
      );
    })
    .catch(error => {
      dispatch(
        newNotification({
          variant: 'error',
          message: error.message
        })
      );
    });

}
